import { ADDITIONAL_DIAGNOSES } from "components/ClientDetails/Sections/Profile/DiagnosticProfile/selectValues";

export const AUTISM_DIAGNOSES_CODE = "F84.0";

export const ASD_SEVERITY = [
  { label: "Level 1", value: "1" },
  { label: "Level 2", value: "2" },
  { label: "Level 3", value: "3" },
  { label: "N/A", value: "n/a" },
];

export const getDiagnosticFormValues = (clientDiagnosis: any) => {
  const diagnosisDate = clientDiagnosis?.diagnosis_date
    ? new Date(clientDiagnosis.diagnosis_date)
    : null;

  return {
    diagnosisId: clientDiagnosis?.diagnosis_id || "",
    diagnosisDate,
    medicalDiagnoses: clientDiagnosis?.medical_diagnoses || [],
    additionalDiagnoses: clientDiagnosis?.additional_diagnoses?.map((d: any) => d.code) || [],
    asdSeveritySocial: clientDiagnosis?.asd_severity_social || "",
    asdSeverityRestricted: clientDiagnosis?.asd_severity_restricted || "",
    iqTest: clientDiagnosis?.iq_test || "",
    iqScore: clientDiagnosis?.iq_score || "",
    cars2Type: clientDiagnosis?.cars_2_type || "",
    cars2TScore: clientDiagnosis?.cars_2_t_score || "",
    evaluationForComorbidDiagnoses: clientDiagnosis?.evaluation_comorbid_diagnoses || "",
    otherSymptomsObserved: clientDiagnosis?.other_symptoms_impairments || "",
    persistentDeficitsSocialCommunication: clientDiagnosis?.persistent_deficits_social || "",
    restrictiveRepetitivePatterns: clientDiagnosis?.restrictive_repetitive_patterns || "",
    treatmentModality: clientDiagnosis?.treatment_modality || "",
  };
};

export const getFormValuesParsedForAPI = (diagnosticFormValues: any) => {
  const { cars2TScore, iqScore, additionalDiagnoses } = diagnosticFormValues;

  const additional_diagnoses = ADDITIONAL_DIAGNOSES.filter((diagnosis: any) =>
    additionalDiagnoses?.includes(diagnosis.code)
  );

  return {
    diagnosis_id: diagnosticFormValues.diagnosisId || null,
    diagnosis_date: diagnosticFormValues.diagnosisDate || null,
    medical_diagnoses: diagnosticFormValues.medicalDiagnoses || [],
    additional_diagnoses,
    asd_severity_social: diagnosticFormValues.asdSeveritySocial || null,
    asd_severity_restricted: diagnosticFormValues.asdSeverityRestricted || null,
    iq_test: diagnosticFormValues.iqTest || null,
    iq_score: iqScore ? Number(iqScore) : null,
    cars_2_type: diagnosticFormValues.cars2Type || null,
    cars_2_t_score: cars2TScore ? Number(cars2TScore) : null,
    evaluation_comorbid_diagnoses: diagnosticFormValues.evaluationForComorbidDiagnoses || null,
    other_symptoms_impairments: diagnosticFormValues.otherSymptomsObserved || null,
    persistent_deficits_social: diagnosticFormValues.persistentDeficitsSocialCommunication || null,
    restrictive_repetitive_patterns: diagnosticFormValues.restrictiveRepetitivePatterns || null,
    treatment_modality: diagnosticFormValues.treatmentModality || null,
  };
};
